export const SUPPORT_EMAIL = 'xpayroll@razorpay.com';
